function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineIntegration, _INTERNAL_copyFlagsFromScopeToEvent, _INTERNAL_insertFlagToScope, _INTERNAL_addFeatureFlagToActiveSpan } from '@sentry/core';
var openFeatureIntegration = defineIntegration(function () {
  return {
    name: 'OpenFeature',
    processEvent: function processEvent(event, _hint, _client) {
      return _INTERNAL_copyFlagsFromScopeToEvent(event);
    }
  };
});

/**
 * OpenFeature Hook class implementation.
 */
var OpenFeatureIntegrationHook = /*#__PURE__*/function () {
  function OpenFeatureIntegrationHook() {
    _classCallCheck(this, OpenFeatureIntegrationHook);
  }
  return _createClass(OpenFeatureIntegrationHook, [{
    key: "after",
    value:
    /**
     * Successful evaluation result.
     */
    function after(_hookContext, evaluationDetails) {
      _INTERNAL_insertFlagToScope(evaluationDetails.flagKey, evaluationDetails.value);
      _INTERNAL_addFeatureFlagToActiveSpan(evaluationDetails.flagKey, evaluationDetails.value);
    }

    /**
     * On error evaluation result.
     */
  }, {
    key: "error",
    value: function error(hookContext, _error, _hookHints) {
      _INTERNAL_insertFlagToScope(hookContext.flagKey, hookContext.defaultValue);
      _INTERNAL_addFeatureFlagToActiveSpan(hookContext.flagKey, hookContext.defaultValue);
    }
  }]);
}();
export { OpenFeatureIntegrationHook, openFeatureIntegration };